import React from 'react'

const FooterCollapseData = [
    {
        key: "1",
        label: <span className='text-[#fff] text-[20px] font-poppins-regular'>Location </span>,
        children: <p className="text-[#fff] text-[14px] font-poppins-regular"> Dallas, Texas </p>,
        style: { background: '#000' }
    },
    {
        key: "2",
        label: <span className='text-[#fff] text-[20px] font-poppins-regular'>Support </span>,
        children: <p className="text-[#fff] text-[14px] font-poppins-regular"> +1 (214) 406‑0717 <br /> <br />hello@aaphotobooth360.com </p>,
        style: { background: '#000', borderWidth: '0px 0px 1px 0px', borderColor: '#5e5e5e', borderStyle: 'solid' }
    },
];
export default FooterCollapseData